import script from "./VideoWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./VideoWrapper.vue?vue&type=style&index=0&id=c7c55a52&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7c55a52"]])

export default __exports__